import React from 'react';
import ModernHeader from '../components/ModernHeader';

const RefundPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ModernHeader />
      
      <main className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
            <h1 className="text-3xl font-bold leading-6 text-gray-900">
              Cancellation & Refund Policy
            </h1>
            <p className="mt-2 max-w-2xl text-sm text-gray-500">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
          
          <div className="px-4 py-8 sm:px-6 space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Cancellations</h2>
              <p className="text-gray-600 leading-relaxed">
                We offer digital educational content (courses, videos, and materials). 
                Once a purchase is made and the content is credited to your account, 
                <strong> no cancellations are permitted</strong>. Please ensure you have 
                reviewed the course curriculum and demo videos (if available) before 
                making a purchase.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">2. Refunds</h2>
              <p className="text-gray-600 leading-relaxed">
                Due to the nature of digital goods, all sales are final. 
                <strong> We do not offer refunds</strong> for any courses or digital 
                resources purchased through our platform. Once access is granted, 
                the service is considered fully rendered.
              </p>
            </section>

            <section className="bg-blue-50 p-4 rounded-lg">
              <h2 className="text-lg font-medium text-blue-900 mb-2">Contact Us</h2>
              <p className="text-blue-800 text-sm">
                If you encounter any technical issues or have trouble accessing your 
                purchased content, please contact our support team at 
                <span className="font-semibold"> lawfullingo2017@gmail.com</span>.
              </p>
            </section>
          </div>
        </div>
      </main>

    </div>
  );
};

export default RefundPolicyPage;